module.exports = __webpack_public_path__ + "img/NemaBattus.c74e7d4e.png";